import(/* webpackMode: "eager" */ "/app/front_end/src/app/(main)/error.tsx");
